import tippy, {hideAll} from 'tippy.js';

var camp_360_tooltips = document.querySelectorAll('[data-camp-tooltip]');

camp_360_tooltips.forEach(tooltip => {
    if(!tooltip.dataset) {
        return;
    }

    var tooltip_content = document.querySelector(tooltip.dataset.campTooltip);

    var tipConfig = {
        content: tooltip_content,
        theme: 'light-border',
        followCursor: true,
        offset: [0, 30],
        duration: [200, 100]
    }

    if(tooltip.dataset.placement && window.innerWidth >= 1024) {
        tipConfig.placement = tooltip.dataset.placement;
    }
    
    var tippyTip = tippy(tooltip, tipConfig);

    if(tooltip.dataset.autoStart) {
        autoTipInView(tippyTip, tooltip);
    }

    tooltip.addEventListener('mouseenter', () => {
        hideAll({exclude: tippyTip});
    });

    tooltip.addEventListener('click', () => {
        hideAll({exclude: tippyTip});
    });
});

function autoTipInView(tippyTip) {
    if(typeof IntersectionObserver !== 'undefined') {
        return;
    }
    
    const initInview = () => {
        let options = {
            root: document.querySelector('[page]'),
            rootMargin: '0px',
            threshold: .1
        }
    
        let setInview = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.setTimeout(() => {
                        tippyTip.show();
                    }, 1500);

                    observer.unobserve(entry.target);
                }
            });
        }

        let observer = new IntersectionObserver(setInview, options);
        observer.observe(document.getElementById('camp-360'));
    }
    
    window.setTimeout(initInview, 1200);
}